module.exports = __webpack_public_path__ + "static/media/tips.94ffbad7.svg";